// mapbox
import { ref } from '@vue/composition-api';
import mapboxgl from 'mapbox-gl';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';

export const useGeometryHoverHook = () => {
    //refs
    const hoveredStateId = ref(null);
    const tempElement = ref();
    const tempGeoRecordId = ref();

    // hooks
    const {
        addHighlightGeoRecordExtrusion,
        removeHighlightGeoRecordExtrusion,
    } = useGeoRecord();

    const highlightGeometry = (e: any, map: mapboxgl.Map, source: string) => {
        if (e.features === undefined) {
            if (hoveredStateId.value !== null) {
                map.setFeatureState(
                    { source: source, id: hoveredStateId.value },
                    { hover: false },
                );
            }
            hoveredStateId.value = null;
            map.getCanvas().style.cursor = '';
        } else if (e.features.length > 0) {
            if (hoveredStateId.value !== null) {
                map.setFeatureState(
                    { source: source, id: hoveredStateId.value },
                    { hover: false },
                );
                map.getCanvas().style.cursor = 'pointer';
            }
            hoveredStateId.value = e.features[0].id;
            map.setFeatureState(
                { source: source, id: hoveredStateId.value },
                { hover: true },
            );
        }
    };

    const highlightGeoRecordExtrusions = (
        e: any,
        map: mapboxgl.Map,
        source: string,
    ) => {
        var features = map.queryRenderedFeatures(e.point, {
            layers: [source],
        });

        if (features.length > 0) {
            map.getCanvas().style.cursor = 'pointer';
            map.getSource('geo-records-extrusion')._data.features.forEach(
                (element) => {
                    if (element.id === features[0].id) {
                        tempElement.value = { ...element };
                        if (tempGeoRecordId.value !== element.id) {
                            addHighlightGeoRecordExtrusion(map, element);
                            tempGeoRecordId.value = element.id;
                        }
                    }
                },
            );
        } else {
            tempGeoRecordId.value = undefined;
            map.getCanvas().style.cursor = '';
            removeHighlightGeoRecordExtrusion(map, tempElement.value);
        }
    };

    return {
        highlightGeoRecordExtrusions,
        highlightGeometry,
    };
};
